export default __webpack_public_path__ + "static/media/graph-type-1-cropped.4ec49a71.png";